//import logoBlue from './pangea-blue.png'; // Update this path to correctly point to your image file
import { Outlet, useParams } from "react-router-dom"; // import Outlet
import { useEffect, useState } from 'react';
import "./Layout.scss"
import { sendXhrCall } from '../../utils/helpers';
import config from '../../config';
import DownloadPopup from '../../components/Download-popup/Download-popup';

export function Layout({ mobile, openModal, closeModal, modalIsOpen }: any) {
    const { userId } = useParams();

    const [userData, setUserData] = useState({ user: { firstName: '',lastName: '',  picture: '', username: '' }, placesCount: 0, recsCount: 0, countryCount: 0, tripsCount: 0 })

    const fetcUserDetails = async (userId: string) => {
        let userDataFromAPI = await sendXhrCall(config.apigateway.userDetailsApi + userId, 'get');
        setUserData(userDataFromAPI)
    }

    useEffect(() => {
        userId && fetcUserDetails(userId)
    }, [userId])

    let usermetadata = [
        {
            count: userData.countryCount,
            title: "Countries"
        },
        {
            count: userData.tripsCount,
            title: "Trips"
        }, {
            count: userData.recsCount,
            title: "Recs"
        }
    ];

    /*
    <header className="Header">
        <div className="header-info">
            <img
                src={logoBlue}
                alt="Logo"
                style={{ height: '22px' }}
            />
            <div className="header-text">Explore the world, together</div>
        </div>
        <button className="open-app-btn" onClick={openModal}>Open App</button>
    </header>
    */

    return (
        <div className="Layout-container">
            <div className="User-profile-container" style={{ width: 350 }}>
                <div className="User-profile">
                    <img
                        src={userData.user.picture || "http://www.gravatar.com/avatar/?d=mp"}
                        alt="User"
                        className={mobile === true ? "Profile-image" : "Profile-image-desktop"}
                    />
                    <div className="User-details">
                        <div className="User-name-container">
                            <p className="User-name">
                                {userData.user.firstName + " " + userData.user.lastName} 
                            </p>
                        </div>
                        <div className="User-meta">
                            {usermetadata.map((umd)=> <div className="User-meta-container" key={umd.title}>
                                <p className="User-meta-count">
                                    {umd.count}
                                </p>
                                <p className="User-meta-title">
                                {umd.title}
                                </p>
                            </div>)}
                        </div>
                        <button className="Connect-btn" onClick={openModal}>+ Connect</button>
                    </div>
                    
                </div>
                
            </div>
             
            
            <DownloadPopup openModal={openModal} closeModal={closeModal} modalIsOpen={modalIsOpen}/>
            <Outlet />
        </div>
    );
}

